import { computed } from '@ember/object';
import { not } from '@ember/object/computed';

import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import { trackedFunction } from 'reactiveweb/function';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  interpreter: validator('presence', true),
  type: validator('presence', true),
  redirect: validator('format', {
    regex: /https:\/\/[a-z0-9-.]+\.[a-z0-9-.]+\/?.*/,
    blank: true,
    disabled: not('model.hasTargets'),
  }),
  documentRoot: validator('presence', {
    presence: true,
    disabled: not('model.hasMountpoint'),
  }),
  domains: [validator('has-many'), validator('presence', true)],
});

export default class VhostModel extends Model.extend(Validations) {
  @attr('string') documentRoot;
  @attr('string') firstDomainName;
  @attr('string') fpmTemplate56;
  @attr('string') fpmTemplateAdm56;
  @attr('string') information;
  @attr('string', { defaultValue: 'php85' }) interpreter;
  @attr('boolean', { defaultValue: false }) monitoring;
  @attr('string') redirect;
  @attr('boolean') redirectKeepPath;
  @attr('string') type;
  @attr('string') vhostTemplate;
  @attr('string') vhostTemplate56;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('domain', { async: true, inverse: null }) domains;
  @hasMany('mlp', { async: true, inverse: null }) mlps;

  // Functions
  loadPreviewMlps = trackedFunction(this, async () => {
    let mlps = await this.mlps;
    return mlps.filter((mlp) => mlp.isPreview);
  });

  // Getter and setter
  get previewMlps() {
    return this.loadPreviewMlps.value ?? [];
  }

  get displayHeadline() {
    return this.firstDomainName;
  }

  get displayLabel() {
    return `${this.firstDomainName} (${this.id})`;
  }

  @computed('type')
  get hasTargets() {
    return this.type === 'REDIRECT';
  }

  @computed('type')
  get hasMountpoint() {
    return this.type !== 'REDIRECT';
  }
}
